<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { getIndex, setLocation, generateUUID } from "@/utils";
import moment from "moment";
import swal from "sweetalert";

import { getLocations, getLocationGroup } from "@/api/locations";
import {getRFMGraphData, getRFMMarketingRecom, getRFMNewVsRepeatData } from "@/api/analytics";
import {getRevenueCenters} from "@/api/campaigns";

const startOfMonth = moment()
  .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");

const endOfMonth = moment()
  .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "rfm-dashboard",
  components: {
    VueCtkDateTimePicker,
  },
  data() {
    return {
      form: {
        selectedItems: [],
        selectedLocationOrGroup: "locations",
        dtpicker: { start: startOfMonth, end: endOfMonth },
        selectedYearOver: "abs",
        newVsRepeatSelectedYearOver: "abs",
        selectedCustomerType: ["all"],
        selectedCategoryOptions: 'sales',
        newVsRepeatSelectedCategoryOptions: { text: "Sales", value: "sales" },
        // selectedRevenueList: ['in-store',"online","delivery"],
        selectedRevenueList: [],
        selectedGraphCheckbox:[],
      },
      maxDate: moment().format("YYYY-MM-DD"),
      overYearOption: [
        { text: "Absolute Value", value: "abs"},
        { text: "Year over Year", value: "yoy"},
        { text: "Month over Month", value: "mom"},
        { text: "Rolling Average (30 days)", value: "rolling-30"},
        { text: "Rolling Average (60 days)", value: "rolling-60"},
        { text: "Rolling Average (90 days)", value: "rolling-90"},
        { text: "Rolling Average (120 days)", value: "rolling-120"},
        { text: "Rolling Average (180 days)", value: "rolling-180"}
      ],
      newVsRepeatOverYearOption: [
        { text: "Absolute Value", value: "abs"},
        { text: "Year over Year", value: "yoy"},
        { text: "Month over Month", value: "mom"},        
      ],
      customerType: [
        { text: "All", value: "all"},
        { text: "Trackable", value: "trackable"},
        { text: "Marketable", value: "marketable"}
      ],
      locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      categoryOptions: [
        { text: "Sales", value: "sales" },
        { text: "Average Check", value: "average_check" },
        { text: "Traffic", value: "traffic" },
        { text: "Recency", value: "recency" },
        { text: "Frequency", value: "frequency" }
      ],
      newVsRepeatCategoryOptions: [
        { text: "Sales", value: "sales" },
        { text: "Average Check", value: "average_check" },
        { text: "Traffic", value: "traffic" },
        // { text: "Recency", value: "recency" },
        // { text: "Frequency", value: "frequency" }
      ],
      headers: [
        {
          text: "Location/'s",
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Year over year', value: 'yoy' },
        { text: 'Metric 1', value: 'metric' },
        { text: 'Metric Comparison', value: 'metric_comp' },
        { text: 'Year over 2 year', value: 'yoy2' },
        { text: 'Metric Est.', value: 'metric_est' },
      ],
      dataItems: [
        {
          name: 'california fish grill San jose',
          yoy: '2',
          metric: 4.0,
          metric_comp: 3.0,
          yoy2: 64,
          metric_est: 43,
        },
        {
          name: 'california fish grill Glendale',
          yoy: '5',
          metric: 34.0,
          metric_comp: 32.0,
          yoy2: 84,
          metric_est: 23,
        }
        
      ],
      selectedLocationGroups: [],
      grouplocationsOptionsv2:[],
      grouplocationsOptionsv2Copy:[],
      graph_stroke: 0,
      groups:[],
      locations: [],
      searchTerm: null,
      searchGraph: null,
      searchLocationGroupTerm: null,
      locationsCopy: [],
      maxDisplay: 1,
      snackbar: false,
      text: "",
      timeout: 2000,
      vertical: true,
      firstLoadDone: false,
      loading: false,
      loadingCircle: false,
      overlayText: "Please select Campaign",
      stickyNav: '',
      options: {},
      seriesOptions: [],
      chartOptions: {},
      newVsRepeatSeriesOptions:[],
      newVsRepeatChartOptions: {},
      new_customers_change:null,
      repeat_customers_change:null,
      new_customers_pct_change:null,
      repeat_customers_pct_change:null,
      new_customers_change_positive:true,
      repeat_customers_change_positive:true,
      datePeriod:'',
      responseCopy: null,
      revenueCenterList:[
        { text: "In-Store", value: "in-store" },
        { text: "Online", value: "online" },
        { text: "Delivery", value: "delivery" }
      ],
      graphCheckboxList:[],      
      searchTextTable: '',
      openPanel: [0,1,2],
      marketingRecommendations:{
          "sales": {
              "abs": 0,
              "yoy_abs_chg": 0,
              "yoy_pct": 0,
          },
          "traffic": {
              "abs": 0,
              "yoy_abs_chg": 0,
              "yoy_pct": 0,
          },
          "average_check": {
              "abs": 0,
              "yoy_abs_chg": 0,
              "yoy_pct": 0,
          },
          "frequency": {
              "abs": 0,
              "yoy_abs_chg": 0,
              "yoy_pct": 0,
          },
          "recency": {
              "abs": 0,
              "yoy_abs_chg": 0,
              "yoy_pct": 0,
          }
      },
      marketingEachClass:{
        sales: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        traffic: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        averageChk: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        frequency: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        recency: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
      }
    };
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "RFM Dashboard" }]);
    this.goLoad()
    await this.firstLoadDatePick();

    try {
      let location = await getLocations();
      let locationGroup = await getLocationGroup();
      
      this.locations = location
      let index = this.getIndex(this.locations);
      let selected = this.locations[index];
      // this.form.selectedItems.push(selected.id);
      // this.form.selectedItems = this.form.selectedItems.flat()

      this.groups = locationGroup
      this.$nextTick(() => {
        this.setLocationGroups()
        this.setLocations()
      })

      let revenueCenterList = await getRevenueCenters()
      this.revenueCenterList = [{value:'all',text:"All"},
        ...revenueCenterList.map(list => {
          return {
            value: list.name.toLowerCase(),
            text: list.name
          };
        })
      ];
      this.form.selectedRevenueList= [this.revenueCenterList[0]['value']],

      setTimeout(() => {
        // this.openPanel = [0]
      }, 100);
      
      this.doneLoad()
      setTimeout(() => {
        this.onSearch()
      }, 100);

    } catch (error) {
      console.log('- Error: ', error)
      this.loading = true
      this.loadingCircle = false
      this.overlayText = "Something went wrong. Please try again later"
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    locationsOptions(){
      return this.locations.map((list) => {
          return {
            value: list.id,
            text: `${list.name} ${list.full_address}`,
            name: list.name,
            full_address: list.full_address,
          };
        });
    },
    chartId() {
      return `chart_${generateUUID()}`;
    },
    likesAllItemsRevenue() {
      return this.form.selectedRevenueList.length === this.revenueCenterList.length;
    },
    likesSomeItemRevenue() {
      return this.form.selectedRevenueList.length > 0 && !this.likesAllItems;
    },
    likesAllGraphLocation() {
      return this.form.selectedGraphCheckbox.length === this.graphCheckboxList.length;
    },
    likesSomeGraphLocation() {
      return this.form.selectedGraphCheckbox.length > 0 && !this.likesAllGraphLocation;
    },
    likesAllCustomerType() {
      return this.form.selectedCustomerType.length === this.customerType.length;
    },
    likesSomeCustomerType() {
      return this.form.selectedCustomerType.length > 0 && !this.likesAllCustomerType;
    },
    likesAllItems() {
      return this.form.selectedItems.length === this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.form.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesSomeItem) return "mdi-minus-box";
      if (this.likesAllItems) return "mdi-close-box";   
      return "mdi-checkbox-blank-outline";
    },
    iconRevenue() {
      if (this.likesAllItemsRevenue) return "mdi-close-box";    
      if (this.likesSomeItemRevenue) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconCustomer() {
      if (this.likesAllCustomerType) return "mdi-close-box";
      if (this.likesSomeCustomerType) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconGraphLoc(){
      if (this.likesAllGraphLocation) return "mdi-close-box";
      if (this.likesSomeGraphLocation) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() {
      return this.selectedLocationGroups.length === 30  || this.selectedLocationGroups.length === this.grouplocationsOptionsv2.length;
    },
    likesSomeGroupItem() {
      return this.selectedLocationGroups.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    filteredItems() {
      return this.graphCheckboxList.filter(item => {
            if(!this.searchGraph) return this.graphCheckboxList;
            return (item.text.toLowerCase().includes(this.searchGraph.toLowerCase()) );
      })
    },
    getNewVsRepeatKpiUnit(){
      if(this.form.newVsRepeatSelectedCategoryOptions.value=='sales'|| this.form.newVsRepeatSelectedCategoryOptions.value=='average_check'){
        return "$"}
      else if(this.form.newVsRepeatSelectedCategoryOptions.value=='traffic'){
        return " people"
      }
      else if(this.form.newVsRepeatSelectedCategoryOptions.value=='recency'){
        return " days"
      }
      else if(this.form.newVsRepeatSelectedCategoryOptions.value=='frequency'){
        return " visits"
      }
      
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    },
    "form.selectedItems"() {
      this.form.location_ids = this.form.selectedItems
    },
    "form.dtpicker"(newVal) {
      if (newVal == undefined) {
        // this.form.dtpicker = { start: startOfMonth, end: endOfMonth };
        let last365 = moment(this.maxDate).subtract(1, "years");
        last365 = last365.format("YYYY-MM-DD");
        let today = moment(this.maxDate);
        today = today.format("YYYY-MM-DD");

        this.form.dtpicker  = { start: last365, end: today };
      }
    },
    "form.selectedYearOver"(){
      this.onSearch()
    },
    "form.selectedCategoryOptions"(){
      this.onSearch()
    },
    "form.selectedGraphCheckbox"(){
      // console.log("Rerender graph with values:",this.form.selectedGraphCheckbox);
      let formattedData = this.formatResponse(this.responseCopy)
      this.recomputeSeries(formattedData)
    },
    "form.newVsRepeatSelectedYearOver"(){
      this.new_customers_change=null
      this.repeat_customers_change=null
      this.new_customers_pct_change=null
      this.repeat_customers_pct_change=null
      this.newVsRepeatSeriesOptions = []
      this.onSearch()
    },
    "form.newVsRepeatSelectedCategoryOptions"(){
      this.new_customers_change=null
      this.repeat_customers_change=null
      this.new_customers_pct_change=null
      this.repeat_customers_pct_change=null
      this.newVsRepeatSeriesOptions = []
      this.onSearch()
    }   
  },
  methods: {
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    displayFloat(value){
      return parseFloat(value)
    },
    displayMoneyFormatAmount(value) {
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));
      if (total_num < 0) {
        let x = total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        return "$" + Math.abs(x);
      }
      return "$" + total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    displayPercentageFormatValue(value) {
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));      
      return total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")+"%";
    },
    displayCommaSeparatedInt(value){
      let total_string = "" + value;
      let total_num = parseInt(total_string.replace(/,/g, ""));
      return total_num.toLocaleString()
    },
    displayCommaSeparatedNumber(value){
      // Convert to String
      let total_string = "" + value;
      // Convert to number and remove comma
      let total_num = parseFloat(total_string.replace(/,/g, ""));        
      return total_num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    trafficRecommendationDiffAbs() {
      return Math.round(Math.abs(this.trafficRecommendationDiff))
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toggleRevenue() {
      this.$nextTick(() => {
        if (this.likesAllItemsRevenue) {
          this.form.selectedRevenueList = [];
        } else {
          let data = [];
          for (let i = 0; i < this.revenueCenterList.length; i++) {
            let item = this.revenueCenterList[i];
            data.push(item.value);
          }
          this.form.selectedRevenueList = data;
        }
      });
    },
    toggleGraphLocation() {
      this.$nextTick(() => {
        if (this.likesAllGraphLocation) {
          this.form.selectedGraphCheckbox = [];
        } else {
          let data = [];
          for (let i = 0; i < this.graphCheckboxList.length; i++) {
            let item = this.graphCheckboxList[i];
            data.push(item.value);
          }
          this.form.selectedGraphCheckbox = data;
        }
      });
    },
    toggleCustomerType() {
      this.$nextTick(() => {
        if (this.likesAllCustomerType) {
          this.form.selectedCustomerType = [];
        } else {
          let data = [];
          for (let i = 0; i < this.customerType.length; i++) {
            let item = this.customerType[i];
            data.push(item.value);
          }
          this.form.selectedCustomerType = data;
        }
      });
    },
    exportItems(){

    },
    goLoad(){
      this.loading = true
      this.loadingCircle = true
      this.overlayText = "Loading ...."
    },
    doneLoad(){
      this.loading = false
    },
    handleScroll (event) {
      this.stickyNav = ''
      if(window.top.scrollY >= 80){
        this.stickyNav = 'stick-nav'
      }
    },
    setLocations() {
      this.snackbar = true;
      this.text = "Loading locations...";
      this.locationsCopy = [...this.locationsOptions];
      this.form.selectedItems.push(this.locationsOptions.map(list => list.value))
      this.form.selectedItems = this.form.selectedItems.flat()

      // this.onSearch();
      this.snackbar = false;
    },
    setLocationGroups() {
      this.grouplocationsOptionsv2 = [
        ...this.groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.grouplocationsOptionsv2Copy = [...this.grouplocationsOptionsv2];

      let defaultSelected = this.grouplocationsOptionsv2.filter(list => list.name == "All Locations");
      this.selectedLocationGroups.push(defaultSelected[0].value)
      this.selectedLocationGroups = this.selectedLocationGroups.flat()
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          this.selectedLocationGroups = [];
        } else {
          let data = [];
          for (let i = 0; i < this.grouplocationsOptionsv2.length; i++) {
            let item = this.grouplocationsOptionsv2[i];
            data.push(item);
          }
          this.selectedLocationGroups = data;
        }
      });
    },
    capitalize(str) {
      if(!str){
        return ''
      }
      return (str = str
      .split(" ")
      .map(
        ([firstChar, ...rest]) =>
          firstChar.toUpperCase() + rest.join("").toLowerCase()
      )
      .join(" "));
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.form.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item.value);
          }
          this.form.selectedItems = data;
          this.form.selectedItems = this.form.selectedItems.flat()
          console.log('-=-=- ALL: ',this.form.selectedItems)
        }
      });
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
     
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.grouplocationsOptionsv2.length == 0) {
        this.grouplocationsOptionsv2 = this.grouplocationsOptionsv2Copy;
      }
      this.grouplocationsOptionsv2 = this.grouplocationsOptionsv2.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    async onSearch() {
      try {
        this.goLoad()
        console.log('--:',this.form.selectedItems.length)
        
        if ((this.form.selectedItems.length <= 0 && this.selectedLocationGroups.length <= 0) || 
            this.form.selectedCustomerType <= 0 ||
            this.form.selectedRevenueList <= 0 ){
          swal("Notice", "Please fill up the filter before Search.");
          this.$nextTick(() => {
            this.doneLoad()
          })
          return false
        }

        let payload = {}
        payload["kpi"] = this.form.selectedCategoryOptions
        payload["location_type"] = this.form.selectedLocationOrGroup
        if (this.form.selectedLocationOrGroup =="location_groups"){
          payload["location_ids"] = this.selectedLocationGroups
        }
        else{
          payload["location_ids"] = this.form.selectedItems
        }
        payload["start_date"] =this.form.dtpicker.start
        payload["end_date"] = this.form.dtpicker.end
        payload["range_type"] = this.form.selectedYearOver 
        payload["customer_types"] = this.form.selectedCustomerType
        payload["channel_types"] = this.form.selectedRevenueList

        let payload2 = {}
        payload2["kpi"] = this.form.newVsRepeatSelectedCategoryOptions.value
        payload2["location_type"] = this.form.selectedLocationOrGroup
        if (this.form.selectedLocationOrGroup =="location_groups"){
          payload2["location_ids"] = this.selectedLocationGroups
        }
        else{
          payload2["location_ids"] = this.form.selectedItems
        }
        payload2["start_date"] =this.form.dtpicker.start
        payload2["end_date"] = this.form.dtpicker.end
        payload2["range_type"] = this.form.newVsRepeatSelectedYearOver 
        payload2["customer_types"] = this.form.selectedCustomerType
        payload2["channel_types"] = this.form.selectedRevenueList
        
        const responses = await Promise.all([
        getRFMGraphData(payload),
        getRFMMarketingRecom(payload),  
        getRFMNewVsRepeatData(payload2)
        ]);
        this.responseCopy = responses[0]
        this.marketingRecommendations = responses[1]
        this.updateClassTile()
        let formattedData = this.formatResponse(this.responseCopy)
        this.recomputeSeries(formattedData)
        
        this.newVsRepeat = responses[2]
        let formattedNewVsRepeatData = this.formatNewVsRepeatResponse(this.newVsRepeat)
        this.computeNewVsRepeatSeries(formattedNewVsRepeatData)
        this.onChangeReveuLocationAndCustomerType()
        
        this.$nextTick(() => {
            this.doneLoad()
          })
      } catch (error) {
        console.log("Error in search:",error)
      }
      
    },
    updateClassTile(){
      this.marketingEachClass = {
        sales: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        traffic: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        averageChk: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        frequency: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
        recency: {
          change: 'green--text',
          changeIcon: '+',
          pct: 'green--text',
          pctIcon: '+',
        },
      }

      if (this.marketingRecommendations['sales']['yoy_abs_chg'] < 0 ){
        this.marketingEachClass['sales']['change'] = "red--text"
        this.marketingEachClass['sales']['changeIcon'] = ""
      }
      if (this.marketingRecommendations['sales']['yoy_pct'] < 0 ){
        this.marketingEachClass['sales']['pct'] = "red--text"
        this.marketingEachClass['sales']['pctIcon'] = ""
      }

      if (this.marketingRecommendations['traffic']['yoy_abs_chg'] < 0 ){
        this.marketingEachClass['traffic']['change'] = "red--text"
        this.marketingEachClass['traffic']['changeIcon'] = ""
      }
      if (this.marketingRecommendations['traffic']['yoy_pct'] < 0 ){
        this.marketingEachClass['traffic']['pct'] = "red--text"
        this.marketingEachClass['traffic']['pctIcon'] = ""
      }

      if (this.marketingRecommendations['average_check']['yoy_abs_chg'] < 0 ){
        this.marketingEachClass['averageChk']['change'] = "red--text"
        this.marketingEachClass['averageChk']['changeIcon'] = ""
      }
      if (this.marketingRecommendations['average_check']['yoy_pct'] < 0 ){
        this.marketingEachClass['averageChk']['pct'] = "red--text"
        this.marketingEachClass['averageChk']['pctIcon'] = ""
      }

      if (this.marketingRecommendations['frequency']['yoy_abs_chg'] < 0 ){
        this.marketingEachClass['frequency']['change'] = "red--text"
        this.marketingEachClass['frequency']['changeIcon'] = ""
      }
      if (this.marketingRecommendations['frequency']['yoy_pct'] < 0 ){
        this.marketingEachClass['frequency']['pct'] = "red--text"
        this.marketingEachClass['frequency']['pctIcon'] = ""
      }

      if (this.marketingRecommendations['recency']['yoy_abs_chg'] < 0 ){
        this.marketingEachClass['recency']['change'] = "red--text"
        this.marketingEachClass['recency']['changeIcon'] = ""
      }
      if (this.marketingRecommendations['recency']['yoy_pct'] < 0 ){
        this.marketingEachClass['recency']['pct'] = "red--text"
        this.marketingEachClass['recency']['pctIcon'] = ""
      }
     
    },
    async firstLoadDatePick() {
      var accountSetting = await this.$store.getters["getAccountSettings"];
      if (!accountSetting.length){
        await this.$store.dispatch("getAccountSettings");
        accountSetting = await this.$store.getters["getAccountSettings"];
      }
      let aggregatedDate = accountSetting.company_details.company['aggregated_date']
      this.maxDate = moment(aggregatedDate).format("YYYY-MM-DD")
      
      if (!this.firstLoadDone) {
        this.firstLoadDone = true;

        let current = new Date();

        let enddate = `${current.getFullYear()}-${current.getMonth() +
          1}-${current.getDate()}`;
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() +
          1}-${current.getDate()}`;
        
        this.form.dtpicker.start = startdate; // this set the value of date picker //initial first load set date range
        this.form.dtpicker.end = enddate;
        if ( moment(this.maxDate).format("YYYY-MM-DD") < moment(enddate).format("YYYY-MM-DD") ){
          let last365 = moment(this.maxDate).subtract(1, "years");
          last365 = last365.format("YYYY-MM-DD");
          this.form.dtpicker.start = last365
          this.form.dtpicker.end = moment(this.maxDate).format("YYYY-MM-DD");
        }
      }
    },
    whenDtClosed() {
      if (this.form.dtpicker.end == null && this.form.dtpicker.start != null) {
        this.form.dtpicker.end = this.form.dtpicker.start;
      }
    },
    formatResponse(response){
      try {
        console.log("Response:",response)        
        let dates = []
        let data = {}
        response.map((item,index)=>{          
          let key =item['location_id']+"-"+item['channel_type']+"-"+item["customer_type"];
          if (this.form.selectedGraphCheckbox.includes(key)){
            if (key in data)
            {
              data[key].push(item['value'])
            }
            else{
              data[key] = [item['value']]
            }
          }
          dates.push(item['date'])
        })
        dates= Array.from(new Set(dates));         
        let formatedData = {
          "dates":dates,
          "data":data
        }        
        return formatedData
      } catch (error) {
        console.log("Error in formatResponse:",error)
      }
      
    },
    recomputeSeries(formattedData){
      try {
        console.log("All Data:",formattedData)
        let dates = formattedData['dates']
        let series = [];
        Object.keys( formattedData['data'] ).forEach( key => {
          let checkbox_option=this.graphCheckboxList.filter((checkbox_object,index)=>checkbox_object.value==key)
          series.push({
            name: `${checkbox_option[0].text}`,
            data: formattedData['data'][key],
            description: `this is ${key} tootltip`,
          });            
        });

        this.seriesOptions = series;
        this.chartOptions = {
          chart: {
            height: 400,
            type: "line",
            toolbar: {
              show: true,
              tools: {
                download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
                customIcons: [],
              },
            },
            events: {
              // updated: () => {
              //   this.setLegendTooltip(registered_baselines);
              // },
              // mounted: () => {
              //   this.setLegendTooltip(registered_baselines);
              // },
            },
          },
          // colors: ["#2E93fA", "#66DA26", "#FF9800", "#E91E63"],
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return `${val}`;
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: this.graph_stroke,
          },
          title: {
            text: ``,
            align: "left",
          },
          // subtitle: {
          //   text: "subtitle here",
          //   align: "left",
          // },
          xaxis: {
            type: "datetime",
            categories: dates,
            labels: {
              formatter: function (value, timestamp) {
                return moment(value).format('MMM-DD-YYYY')
              }, 
            }
          },
          yaxis: {
            show: false,
            showAlways: false,
            labels: {
              show: false,
              formatter: (val)=> {
                let y_val = Math.round(val * 100) / 100;
                if((this.form.selectedCategoryOptions=="sales"||this.form.selectedCategoryOptions=="average_check" )&& (this.form.selectedYearOver=="abs" || this.form.selectedYearOver.includes("rolling")))
                { 
                  return this.displayMoneyFormatAmount(y_val)
                }
                else if((this.form.selectedYearOver!="abs") && !(this.form.selectedYearOver.includes("rolling"))){
                  return this.displayPercentageFormatValue(y_val)
                }
                else{
                  if(this.form.selectedCategoryOptions=="frequency"){
                    return this.displayCommaSeparatedNumber(y_val)+" visits"
                  }
                  else if (this.form.selectedCategoryOptions=="traffic"){
                    return this.displayCommaSeparatedInt(y_val)+" visits"  
                  }  
                  else if((this.form.selectedCategoryOptions=="recency")){
                    return this.displayCommaSeparatedNumber(y_val)+" days"
                  }
                  else return this.displayCommaSeparatedNumber(y_val)                  
                }
              },
            },
          },
          tooltip: {
            x: {
              format: "dd/MM/yy",
              show: true,
            },
            marker: {
              show: true,
            },
          },
          legend: {
            show: false,
            onItemHover: {
              highlightDataSeries: true,
            },
          },
        };
      } catch (error) {
        console.log("Error in recomputeSeries:",error)
      }     
    },
    onChangeDimension() {
      try {
        if (this.form.selectedYearOver.includes("rolling")) {
          this.graph_stroke = 10;
        }
        else {
          this.graph_stroke = 0;
        }
      } catch (error) {
        console.log("Error in onChangeDimension", error)
      }
    },
    onChangeReveuLocationAndCustomerType(){
      try {
        this.graphCheckboxList = []
        if (this.form.selectedLocationOrGroup =="location_groups"){
          console.log("Selected groups:",this.selectedLocationGroups)
          console.log("Group Options:",this.grouplocationsOptionsv2)
          this.selectedLocationGroups.forEach(location_id => {          
            this.form.selectedRevenueList.forEach(revenue_center_id => {              
              this.form.selectedCustomerType.forEach(customer_type => {   
                let key =location_id+"-"+revenue_center_id+"-"+customer_type;  
                let location_object = this.grouplocationsOptionsv2.filter((location_option)=>location_option.value==location_id)  
                let revenue_object = this.revenueCenterList.filter((revenue_option)=>revenue_option.value==revenue_center_id)  
                let customer_type_object = this.customerType.filter((customer_option)=>customer_option.value==customer_type)
                console.log("Location Object:",location_object)
                let text = location_object[0]['name']+" "+ `
                    <span class="font-weight-black">(${customer_type_object[0]['text']  +")  ("+revenue_object[0]['text']})</v-chip>`
                this.graphCheckboxList.push({ text: text, value: key })
                this.form.selectedGraphCheckbox.push(key)              
              })
          })
        }) 
        }
        else{
          this.form.selectedItems.forEach(location_id => {          
            this.form.selectedRevenueList.forEach(revenue_center_id => {              
              this.form.selectedCustomerType.forEach(customer_type => {   
                let key =location_id+"-"+revenue_center_id+"-"+customer_type;  
                let location_object = this.locationsOptions.filter((location_option)=>location_option.value==location_id)  
                let revenue_object = this.revenueCenterList.filter((revenue_option)=>revenue_option.value==revenue_center_id)  
                let customer_type_object = this.customerType.filter((customer_option)=>customer_option.value==customer_type)
                let text = location_object[0]['name']+" "+ `
                    <span class="font-weight-black">(${customer_type_object[0]['text']  +")  ("+revenue_object[0]['text']})</v-chip>`
                this.graphCheckboxList.push({ text: text, value: key })
                this.form.selectedGraphCheckbox.push(key)              
              })
          })
        }) 
        }
               
      } catch (error) {
        console.log("Error in onChangeReveuLocationAndCustomerType",error)
      }
    },
    clearSearch () {
      this.searchGraph=null;
    },
    formatNewVsRepeatResponse(response){
      try {   
        this.new_customers_change=Math.abs(response.new_customers_change)
        this.repeat_customers_change=Math.abs(response.repeat_customers_change)
        this.new_customers_pct_change=Math.abs(response.new_customers_pct_change)
        this.repeat_customers_pct_change=Math.abs(response.repeat_customers_pct_change)
        if(response.new_customers_change > 0){
          this.new_customers_change_positive=true  
        }
        else{
          this.new_customers_change_positive=false
        }
        if(response.repeat_customers_change > 0){
          this.repeat_customers_change_positive=true  
        }
        else{
          this.repeat_customers_change_positive=false
        }        
        let d1 = moment(this.form.dtpicker.start).format("MMM-DD-YYYY").toString();
        let d2 = moment(this.form.dtpicker.end).format("MMM-DD-YYYY").toString();
        this.datePeriod = `From ${d1} to ${d2}`
        return response
      } catch (error) {
        console.log("Error in formatNewVsRepeatResponse:",error)
      }      
    },
    computeNewVsRepeatSeries(formattedData){
      try {        
        let dates = formattedData['dates']
        let series = [];
        Object.keys( formattedData['data'] ).forEach( key => {
          series.push({
            name: `Repeat`,
            data: formattedData['data'][key]['repeat'],
            description: `this is repeat tooltip`,
          });
          series.push({
            name: `New`,
            data: formattedData['data'][key]['new'],
            description: `this is new tooltip`,
          });
          console.log("Key:",key,formattedData['data'][key]['new'])
        })
        this.newVsRepeatSeriesOptions = series;
        this.newVsRepeatChartOptions = {
          chart: {
            height: 400,
            type: "line",
            toolbar: {
              show: true,
              tools: {
                download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
                customIcons: [],
              },
            },
            events: {
              // updated: () => {
              //   this.setLegendTooltip(registered_baselines);
              // },
              // mounted: () => {
              //   this.setLegendTooltip(registered_baselines);
              // },
            },
          },
          // colors: ["#2E93fA", "#66DA26", "#FF9800", "#E91E63"],
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return `${val}`;
            },
          },
          stroke: {
            curve: "smooth",
            dashArray: this.graph_stroke,
          },
          title: {
            text: ``,
            align: "left",
          },
          // subtitle: {
          //   text: "subtitle here",
          //   align: "left",
          // },
          xaxis: {
            type: "datetime",
            categories: dates,
            labels: {
              formatter: function (value, timestamp) {
                return moment(value).format('MMM-DD-YYYY')
              }, 
            }
          },
          yaxis: {
            show: false,
            showAlways: false,
            labels: {
              show: false,
              formatter: (val)=> {
                let y_val = Math.round(val * 100) / 100;
                if((this.form.newVsRepeatSelectedCategoryOptions.value=="sales"||this.form.newVsRepeatSelectedCategoryOptions.value=="average_check" )&& (this.form.newVsRepeatSelectedYearOver=="abs" || this.form.newVsRepeatSelectedYearOver.includes("rolling")))
                { 
                  return this.displayMoneyFormatAmount(y_val)
                }
                else if((this.form.newVsRepeatSelectedYearOver!="abs") && !(this.form.newVsRepeatSelectedYearOver.includes("rolling"))){
                  return this.displayPercentageFormatValue(y_val)
                }
                else{                  
                  if(this.form.newVsRepeatSelectedCategoryOptions.value=="frequency"){
                    return this.displayCommaSeparatedNumber(y_val)+" visits"
                  }
                  else if (this.form.newVsRepeatSelectedCategoryOptions.value=="traffic"){
                    return this.displayCommaSeparatedInt(y_val)+" visits"  
                  }                  
                  else if((this.form.newVsRepeatSelectedCategoryOptions.value=="recency")){
                    return this.displayCommaSeparatedNumber(y_val)+" days"
                  }
                  else return this.displayCommaSeparatedNumber(y_val)                  
                }               
              },
            },
          },
          tooltip: {
            x: {
              format: "dd/MM/yy",
              show: true,
            },
            marker: {
              show: true,
            },
          },
          legend: {
            show: false,
            onItemHover: {
              highlightDataSeries: true,
            },
          },
        };
      } catch (error) {
        console.log("Error in computeNewVsRepeatSeries:",error)
      }  
    },   
  },
  
};
</script>

<template>
  <v-app class="bg-transparent ca-page">
    <v-main>
      <!-- Subheader -->
      <div class="pl-3 pr-3 pt-4 pb-4 d-flex align-items-center justify-content-center zindex-99 filter-container" :class="stickyNav">
        
        <div class="mr-2" style="width: 200px;">
          <VueCtkDateTimePicker
            @is-hidden="whenDtClosed()"
            v-model="form.dtpicker"
            :max-date="maxDate"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select date range"
            range
          />
        </div>

        <div class="mr-2" style="width: 200px;height: 42px;">
          <v-select
            v-model="form.selectedLocationOrGroup"
            :items="locationOrGroupOptions"
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          ></v-select>
        </div>

        <div class="mr-2" style="width: 250px;height: 42px;" v-if="form.selectedLocationOrGroup == 'locations'">
          <v-select
            v-if="form.selectedLocationOrGroup == 'locations'"
            v-model="form.selectedItems"
            :items="locationsOptions"
            @change="onChangeReveuLocationAndCustomerType"
            label="Location"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchTerm"
                    placeholder="Search"
                    @input="filterLocations"
                    @blur="filterLocationsBlur"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedItems.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedItems.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedItems.length }} selected
              </span>
            </template>
            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.full_address }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>


        <div class="mr-2" style="width: 250px;height: 42px;" v-if="form.selectedLocationOrGroup == 'location_groups'">
          <v-select
            v-if="form.selectedLocationOrGroup == 'location_groups'"
            v-model="selectedLocationGroups"
            :items="grouplocationsOptionsv2"
            @change="onChangeReveuLocationAndCustomerType"
            label="Group Location"
            required
            dense
            outlined            
            multiple
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="searchLocationGroupTerm"
                    placeholder="Search"
                    @input="filterLocationGroups"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleLocationGroup">
                <v-list-item-action>
                  <v-icon
                    :color="selectedLocationGroups.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ groupicon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="selectedLocationGroups.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ selectedLocationGroups.length }} selected
              </span>
            </template>
            <template slot="item" slot-scope="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                <v-list-item-action>
                  <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>        
        <div class="mr-2" style="width: 150px;height: 42px;">
          <v-select
            v-model="form.selectedCustomerType"
            :items="customerType"
            @change="onChangeReveuLocationAndCustomerType"
            label="Customer Type"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"  
            width ="50"          
            :menu-props="{ top: false, offsetY: true }"
          >
          <template v-slot:prepend-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleCustomerType">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedCustomerType.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconCustomer }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedCustomerType.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedCustomerType.length }} selected
              </span>
            </template>
        </v-select>
        </div>
        <div class="mr-2" style="width: 150px;height: 42px;">
          <v-select
            label="Revenue Centers"
              v-model="form.selectedRevenueList"
              :items="revenueCenterList"
              @change="onChangeReveuLocationAndCustomerType"
              multiple
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              :menu-props="{ top: false, offsetY: true }"
            >
            <template v-slot:prepend-item>
              <v-divider class="mt-2"></v-divider>
              <v-list-item ripple @click="toggleRevenue">
                <v-list-item-action>
                  <v-icon
                    :color="form.selectedRevenueList.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ iconRevenue }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Select All
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template
              v-if="form.selectedRevenueList.length > 1"
              v-slot:selection="{ item, index }"
            >
              <span v-if="index === maxDisplay">
                {{ form.selectedRevenueList.length }} selected
              </span>
            </template>
          </v-select>
        </div>
        <div>
          <v-btn
            md
            depressed
            color="primary"
            style="height:40px;"
            @click="onSearch()"
            :disabled="loading"
          >
            <v-icon> mdi-magnify</v-icon>
          </v-btn>
        </div>
        
        <div class="tooltip-con">
          <v-tooltip color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="label-txt" 
                v-bind="attrs"
                v-on="on">
                <v-icon
                  > mdi-information-outline
                </v-icon>
              </div>
            </template>
            <span>
              Data on the RFM Dashboard comes from your POS and payment integrations.
            </span>
          </v-tooltip>
        </div>
      </div>


      <v-expansion-panels
        v-model="openPanel"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              RFM Metrics
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="text-center">
              <v-card class=" min-card-height card-con">
                <v-card-title>
                  SALES
                </v-card-title>
                <v-card-text >
                  <div class="d-flex flex-column align-items-start mt-n3">
                    <span>
                      <p class="text-h5 blue--text font-weight-bold">
                        {{displayMoneyFormatAmount(marketingRecommendations['sales']['abs'])}}
                        <span data-v-a4807772="" class="subtitle-2 font-weight-bold pb-2 mid-spa"  :class="marketingEachClass['sales']['change']">
                          {{marketingEachClass['sales']['changeIcon']}}{{displayMoneyFormatAmount(Math.abs(marketingRecommendations['sales']['yoy_abs_chg']))}}
                        </span>
                      </p>
                      
                    </span>
                  </div>
                  <div class="text--primary mt-n2">
                    <span class="font-weight-bold" :class="marketingEachClass['sales']['pct']">
                      <span> {{marketingEachClass['sales']['pctIcon']}}{{(Math.round(marketingRecommendations['sales']['yoy_pct'] * 100)) }}%</span>
                    </span>
                    compared to last year
                  </div>
                </v-card-text>
              </v-card>
              <v-card class=" min-card-height card-con">
                <v-card-title>
                  TRAFFIC
                </v-card-title>
                <v-card-text >
                  <div class="d-flex flex-column align-items-start mt-n3">
                    <span>
                      <p class="text-h5 blue--text font-weight-bold">
                          
                        {{Number(marketingRecommendations['traffic']['abs']).toLocaleString() }}
                        <span data-v-a4807772="" class="subtitle-2  font-weight-bold pb-2 mid-spa" :class="marketingEachClass['traffic']['change']">
                          {{marketingEachClass['traffic']['changeIcon']}}{{Number(marketingRecommendations['traffic']['yoy_abs_chg']).toLocaleString()}}
                        </span>
                      </p>
                    </span>
                  </div>
                  <div class="text--primary mt-n2">
                    <span class="font-weight-bold" :class="marketingEachClass['traffic']['pct']">
                      <span>{{marketingEachClass['traffic']['pctIcon']}}{{Math.round(marketingRecommendations['traffic']['yoy_pct'] * 100)}}%</span>
                    </span>
                    compared to last year
                  </div>
                </v-card-text>
              </v-card>
              <v-card class=" min-card-height card-con">
                <v-card-title>
                  AVERAGE CHECK
                </v-card-title>
                <v-card-text >
                  <div class="d-flex flex-column align-items-start mt-n3">
                    <span>
                      <p class="text-h5 blue--text font-weight-bold">
                          {{displayMoneyFormatAmount(marketingRecommendations['average_check']['abs'])}}
                        <span data-v-a4807772="" class="subtitle-2 font-weight-bold pb-2 mid-spa" :class="marketingEachClass['averageChk']['change']">
                          {{marketingEachClass['averageChk']['changeIcon']}}{{displayMoneyFormatAmount(marketingRecommendations['average_check']['yoy_abs_chg'])}}
                        </span>
                      </p>
                      
                    </span>
                  </div>
                  <div class="text--primary mt-n2">
                    <span class="font-weight-bold" :class="marketingEachClass['averageChk']['pct']">
                      <span>{{marketingEachClass['averageChk']['pctIcon']}}{{Math.round(marketingRecommendations['average_check']['yoy_pct'] * 100)}}%</span>
                    </span>
                    compared to last year
                  </div>
                </v-card-text>
              </v-card>
              <v-card class=" min-card-height card-con">
                <v-card-title>
                  FREQUENCY
                </v-card-title>
                <v-card-text >
                  <div class="d-flex flex-column align-items-start mt-n3">
                    <span>
                      <p class="text-h5 blue--text font-weight-bold">
                          {{marketingRecommendations['frequency']['abs'].toFixed(1)}}
                        <span class="subtitle-1 blue--text font-weight-bold"> visit(s)</span>
                        <span data-v-a4807772="" class="subtitle-2 font-weight-bold pb-2 mid-spa" :class="marketingEachClass['frequency']['change']">
                          {{marketingEachClass['frequency']['changeIcon'] }}{{marketingRecommendations['frequency']['yoy_abs_chg'].toFixed(1)}} visit(s)
                        </span>
                      </p>
                      
                    </span>
                  </div>
                  <div class="text--primary mt-n2">
                    <span class="font-weight-bold" :class="marketingEachClass['frequency']['pct']">
                      <span>{{marketingEachClass['frequency']['pctIcon']}}{{Math.round(marketingRecommendations['average_check']['yoy_pct'] * 100)}}%</span>
                    </span>
                    compared to last year
                  </div>
                </v-card-text>
              </v-card>
              <v-card class=" min-card-height card-con">
                <v-card-title>
                  RECENCY
                </v-card-title>
                <v-card-text >
                  <div class="d-flex flex-column align-items-start mt-n3">
                    <span>
                      <p class="text-h5 blue--text font-weight-bold">
                          {{marketingRecommendations['recency']['abs'].toFixed(1)}} 
                        <span class="subtitle-1 blue--text font-weight-bold"> day(s)</span>
                        <span data-v-a4807772="" class="subtitle-2 font-weight-bold pb-2 mid-spa" :class="marketingEachClass['recency']['change']">
                          {{marketingEachClass['recency']['changeIcon']}}{{marketingRecommendations['recency']['yoy_abs_chg'].toFixed(1)}} day(s)
                        </span>
                      </p>
                    </span>
                  </div>
                  <div class="text--primary mt-n2">
                    <span class="font-weight-bold" :class="marketingEachClass['recency']['pct']">
                      <span>{{marketingEachClass['recency']['pctIcon']}}{{Math.round(marketingRecommendations['recency']['yoy_pct'] * 100)}}%</span>
                    </span>
                    compared to last year
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              RFM Plot
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="local-market-accord">
            <div class="dd-div">
              <div class="ml-4 d-flex" style="width: 350px; height: 42px;">
                <v-select
                  v-model="form.selectedYearOver"
                  :items="overYearOption"
                  label="Dimension"
                  required
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"  
                  width ="50" 
                  style="padding-right: 20px;"
                  @change="onChangeDimension"
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
                <v-select
                  v-model="form.selectedCategoryOptions"
                  :items="categoryOptions"
                  label="KPI Type"
                  required
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"  
                  width ="50"          
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </div>
            </div>
            <v-row class="mb-1">
              <v-col md="9">
                <apexchart
                  :options="chartOptions"
                  :series="seriesOptions"
                  type="line"
                  height="300"
                  style="position:relative; z-index: 1;"
                ></apexchart>
              </v-col>
              <v-col md="3">
                
                <div class="check-box-graph">
                  <div data-v-a4807772="" class="align-items-center" style="
                      text-align: center;
                      font-weight: 600;
                  ">Locations</div>
                  <hr>
                  <v-text-field class="mx-3" flat label="Search" prepend-inner-icon="search" v-model="searchGraph" clearable @click:clear="clearSearch"></v-text-field>
                  <v-list multiple='multiple'>
                    <v-list-item ripple @click="toggleGraphLocation">
                      <v-list-item-action>
                        <v-icon
                          :color="form.selectedGraphCheckbox.length > 0 ? 'indigo darken-4' : ''"
                        >
                          {{ iconGraphLoc }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Select All
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>                    
                    <v-checkbox v-for="(item, index) in filteredItems"
                      :key="index" 
                      v-model="form.selectedGraphCheckbox" 
                      :value="item.value">
                      <template v-slot:label>
                        <div v-html="item.text"></div>
                      </template>
                    </v-checkbox>                      
                  </v-list>                  
                </div>
              </v-col>
            </v-row>
            

          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="accord-lbl">
            <span class="">
              RFM New Vs Repeat
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content
            class="local-market-accord">
            <div class="" v-if="(this.form.newVsRepeatSelectedYearOver!='abs')&&(this.new_customers_change!=null)">
              <v-card class="new-vs-repeat-card-con w-100">
                <v-card-text >
                  <div class="">
                    <span>
                      <p class="text-h5">
                        {{ this.datePeriod }} New Customers {{ this.form.newVsRepeatSelectedCategoryOptions.text }} 
                        <span v-if="new_customers_change_positive">up</span><span v-if="!new_customers_change_positive">down</span> by
                        <span  >
                          <span v-if="form.newVsRepeatSelectedCategoryOptions.value!='sales'&&form.newVsRepeatSelectedCategoryOptions.value!='average_check'" >                          
                            <span v-if="new_customers_change_positive" class="font-weight-bold green--text" >
                              {{ displayCommaSeparatedNumber(this.new_customers_change)+this.getNewVsRepeatKpiUnit}}
                            </span>
                            <span v-if="!new_customers_change_positive" class="font-weight-bold red--text">
                              {{ displayCommaSeparatedNumber(this.new_customers_change)+this.getNewVsRepeatKpiUnit }}
                            </span>
                          </span>
                          <span v-if="form.newVsRepeatSelectedCategoryOptions.value=='sales'||form.newVsRepeatSelectedCategoryOptions.value=='average_check'" >                          
                            <span v-if="new_customers_change_positive" class="font-weight-bold green--text" >
                              {{ this.getNewVsRepeatKpiUnit + displayCommaSeparatedNumber(this.new_customers_change)}}
                            </span>
                            <span v-if="!new_customers_change_positive" class="font-weight-bold red--text">
                              {{ this.getNewVsRepeatKpiUnit + displayCommaSeparatedNumber(this.new_customers_change)}}
                            </span>
                          </span>
                        </span> or 
                        <span v-if="new_customers_change_positive" class="font-weight-bold green--text" >
                          {{ displayPercentageFormatValue(this.new_customers_pct_change)}}
                        </span>
                        <span v-if="!new_customers_change_positive" class="font-weight-bold red--text" >
                          {{ displayPercentageFormatValue(this.new_customers_pct_change)}}
                        </span>
                         and Repeat Customers  {{ this.form.newVsRepeatSelectedCategoryOptions.text }}
                        <span v-if="repeat_customers_change_positive">up</span><span v-if="!repeat_customers_change_positive">down</span> by
                        <span v-if="form.newVsRepeatSelectedCategoryOptions.value!='sales'&&form.newVsRepeatSelectedCategoryOptions.value!='average_check'" >                          
                          <span v-if="repeat_customers_change_positive" class="font-weight-bold green--text" >
                            {{ displayCommaSeparatedNumber(this.repeat_customers_change)+this.getNewVsRepeatKpiUnit}}                          
                          </span>
                          <span v-if="!repeat_customers_change_positive" class="font-weight-bold red--text" >
                            {{ displayCommaSeparatedNumber(this.repeat_customers_change)+this.getNewVsRepeatKpiUnit}}                          
                          </span>
                        </span>
                        <span v-if="form.newVsRepeatSelectedCategoryOptions.value=='sales'||form.newVsRepeatSelectedCategoryOptions.value=='average_check'" >                          
                          <span v-if="repeat_customers_change_positive" class="font-weight-bold green--text" >
                            {{ this.getNewVsRepeatKpiUnit+displayCommaSeparatedNumber(this.repeat_customers_change)}}                          
                          </span>
                          <span v-if="!repeat_customers_change_positive" class="font-weight-bold red--text" >
                            {{ this.getNewVsRepeatKpiUnit+displayCommaSeparatedNumber(this.repeat_customers_change)}}                          
                          </span>
                        </span>
                         or 
                         <span v-if="repeat_customers_change_positive" class="font-weight-bold green--text" >
                          {{ displayPercentageFormatValue(this.repeat_customers_pct_change)}}                          
                        </span>
                        <span v-if="!repeat_customers_change_positive" class="font-weight-bold red--text" >
                          {{ displayPercentageFormatValue(this.repeat_customers_pct_change)}}                          
                        </span>
                      </p>
                      
                    </span>
                  </div>
                  
                </v-card-text>
              </v-card>
            </div>
            <div class="dd-div">
              <div class="ml-4 d-flex" style="width: 350px; height: 42px;">
                <v-select
                  v-model="form.newVsRepeatSelectedYearOver"
                  :items="newVsRepeatOverYearOption"
                  label="Dimension"
                  required
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"  
                  width ="50" 
                  style="padding-right: 20px;"                  
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
                <v-select
                  v-model="form.newVsRepeatSelectedCategoryOptions"
                  :items="newVsRepeatCategoryOptions"
                  label="KPI Type"
                  required
                  return-object
                  dense
                  outlined
                  background-color="#ffffff"
                  height="42"  
                  width ="50"          
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </div>
            </div>
            <v-row class="mb-1">
              <v-col md="12">                
                <apexchart
                  :options="newVsRepeatChartOptions"
                  :series="newVsRepeatSeriesOptions"
                  type="line"
                  height="300"
                  style="position:relative; z-index: 1;"
                ></apexchart>
              </v-col>              
            </v-row>
            

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>







        <!-- <div class="per-section">
          <v-row class="mb-5 pl-5 pr-5">
            <v-col cols="12" md="8">
              <v-btn class="mr-4" color="primary" depressed tile @click="exportItems()">
                <v-icon left> mdi-file-export</v-icon>
                Export
              </v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <b-icon icon="search"></b-icon>
                  </div>
                </div>
                <b-form-input v-model="searchTextTable" placeholder="Search"></b-form-input>
              </div>
            </v-col>
          </v-row>
          <template>
            <v-data-table
              :headers="headers"
              :items="dataItems"
              :items-per-page="5"
              class="elevation-1"
              :show-select="true"
            ></v-data-table>
          </template>
        </div> -->
  
      <div>
        <v-overlay :value="loading">
          <div class="text-center">
            <p>{{overlayText}}</p>
            <v-progress-circular v-if="loadingCircle" indeterminate size="30"></v-progress-circular>
          </div>
        </v-overlay>
        <v-snackbar
          v-model="snackbar"
          :vertical="vertical"
          content-class="background:red"
          color="danger"
          dark
        >
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>

      
    </v-main>
  </v-app>
</template>

<style scoped>
.per-section{
  padding-top: 20px;
  border: 1px solid #00000059;
  border-radius: 25px;
  margin-top: 30px;
}
.card-con{
  text-align: left;
  min-height: 125px;
  box-shadow: none !important;
  border: 1px solid #00000059;
  border-radius: 25px;
  display: inline-block;
  min-width: 250px;
  margin: 0 20px 10px 0;
}
.new-vs-repeat-card-con{
  text-align: left;
  box-shadow: none !important;
  border: 1px solid #00000059;
  border-radius: 25px;
  display: inline-block;
  min-width: 250px;
  margin: 0 20px 10px 0;
}
.filter-container{
    background-color: white;
    margin-bottom: 16px;
    border-radius: 5px;
    /* box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); */
}
.v-tooltip__content {
    width: 50vw !important;
    left: auto !important;
    right: 30px !important;
}
.label-txt{
  color: rgba(0,0,0,.6);
  font-size: 16px;
  padding-bottom: 3px;
  right: 4px;
  bottom: 5px;
  position: relative;
}
.toggler-icon{
  margin-top: 5px;
}
.zindex-99{
  position: relative;
  z-index: 10;
}

.subheader {
  background: #e9eaf3 !important;
}

.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}

.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}

.content-box {
  margin-top: 40px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}
.v-tooltip--bottom {
  background: white;
  color: black;
  border-radius: 16px;
  padding: 5px 10px 4px;
}
.mid-spa{
  position: relative;
  bottom: 5px;
}

@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}
.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.ca-page .v-expansion-panel::before{
  box-shadow: none !important;
}
.stick-nav{
  position: fixed;
  max-width: 84%;
  width: 100%;
  top: 65px;
  background-color: #dee0f4;
}
.stick-nav div{
  float: left;
}
@media only screen and (max-width: 1200px) {
  .stick-nav{
    width: 80%;
  }
}
@media only screen and (max-width: 1050px) {
  .stick-nav{
    width: 76%;
  }
  .stick-nav .v-select {
    max-width: 93px;
  }
}
.dd-div{
  top: 10px;
  position: absolute;
  right: 70px;
}

</style>

<style >
.check-box-graph .v-messages.theme--light.primary--text,
.check-box-graph .v-messages.theme--light {
  display: none !important;
}
.check-box-graph .v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-input--selection-controls.v-input--checkbox.primary--text,
.check-box-graph .v-input.theme--light.v-input--selection-controls.v-input--checkbox{
  margin-top: 0px;
}
.check-box-graph label.v-label.theme--light,
.check-box-graph .v-input__slot {
  margin-bottom: 0px !important;
}
.check-box-graph{
  overflow: auto;
  height: 400px;
  width: 95%;
  padding: 10px 12px;
  margin-bottom: 10px;
  border: 1px solid #00000059;
  border-radius: 10px;
}
.check-box-graph label.v-label.theme--light {
  font-size: 14px;
}
.v-tooltip__content {
  width: 50vw !important;
  left:  auto !important;
  right: 30px !important;
}
.tooltip-con{
  margin: 5px 0 0 10px;
}
</style>
